var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tips-wrapper"},[_c('div',{staticClass:"content"},[_c('img',{staticClass:"arrow",attrs:{"src":require("@/assets/img/mobile/arrow.png")}}),_c('div',{staticClass:"row"},[_vm._v("点击右上角的按钮")]),_c('div',{staticClass:"row"},[_vm._v("选择"),_c('img',{staticClass:"btn-tips",attrs:{"src":require("@/assets/img/mobile/browser_tips.png")}})])])])
}]

export { render, staticRenderFns }